<template>
  <splash></splash>
  <div class="container mt-4" dir="rtl">

    <sidebar></sidebar>
    <div style="    position: absolute;
    right: 28vw;
    width: 51vw; height: auto;" class="card-panel-main col-lg-9 mb-5">

      <div class="card card-body card-panel-box border-0" style="    margin: 1vw .9vw;">
        <div class="col-lg-12">
          <div class="card card-body card-panel-box border-0" style="background-color:unset;">
            <div class="row d-flex justify-content-start">
              <div class="d-flex justify-content-between">
              <h2 style="font-size: 1.2vw !important;width: 12vw;"> واحد های سازمانی</h2>
                <div class="d-flex changer">
                  <p>
                    جدول
                  </p>
                  <router-link to="/pishkhan/Organization/units/chart">
                    نمودار
                  </router-link>
                </div>
              </div>
              <div class="row mb-2 align-items-center justify-content-center">
                <div class="d-flex flex-column col-3 flex-nowrap">
                  <label for="title">
                    عنوان واحد سازمانی
                  </label>
                  <input v-model="name" type="text" class="form-control">
                </div>
                <div class="d-flex flex-column col-3 flex-nowrap">
                  <label for="title">
                   مافوق
                  </label>
                  <v-select class="w-100" :options="all_items" dir="rtl" v-model="parent_item" label="title"
                            style="width: 12vw;   border-radius: .5vw">
                    <template v-slot:no-options>موردی یافت نشد</template>
                  </v-select>
                </div>
                  <button v-if="!editModal" @click.prevent="submitForm" class="btn btn-primary btn-submit-1 mt-4">ذخیره</button>
                  <div v-else class="d-flex align-items-baseline" style="width: 10vw;">
                    <button @click.prevent="update(id)" class="btn btn-primary btn-submit-1 mt-4">ویرایش</button>
                    <Reset @click.prevent="resetItems" style="width: 1.5vw; height: 1.5vw; transform: translateY(0.5vw) translateX(-0.5vw);"/>
                  </div>
              </div>



              <hr>
            </div>
            <center>
              <div class="table-responsive mt-3">
                <div   v-show="!all_items.length">
                  واحد سازمانی خود را یافت نشد.
                </div>
                <div style="overflow-y: scroll; height: 50vw; width: 50vw;" :style="all_items.length < 19 ? 'height: auto;' : ''">

                  <table class="table table-striped" v-show="all_items.length">
                    <thead>
                    <tr>
                      <th style="width: 1vw;">ردیف</th>
                      <th>واحد سازمانی</th>
                      <th>مافوق  </th>
                      <th style="width: 8vw;">عملیات</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(item,index) in all_items" >
                      <td scope="row">{{ index + 1 }}</td>
                      <td> {{item.title}}  </td>
                      <td v-if="item.parent"> {{item.parent.title}}  </td>
                      <td v-else>--</td>



                      <td>



                        <a @click.prevent="editModalMethod(item['id'],item.title, item.parent)" href="#" >
                          <img style="margin-right: .4vw;"
                               class="table-edit-img"
                               src="../../assets/img/pen.svg"
                               alt="edit"></a>
                        <a @click.prevent="deleteModalMethod(item['id'])" href="#" >
                          <img style="margin-right: .4vw;"
                               class="table-edit-img"
                               src="../../assets/img/delete.svg"
                               alt="edit"></a>

                      </td>
                    </tr>

                    </tbody>
                  </table>
                </div>
              </div>
            </center>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Jobs -->



  <!-- modal  -->
  <div dir="rtl" class="modal__error slide-top" v-show="deleteModal" style="z-index: 999999999999999">
    <div>
      <p>حذف</p>
      <p @click="deleteModal=!deleteModal">❌</p>
    </div>
    <div>
      <p>آیا میخواهید حذف کنید!</p>

      <div class="form-buttons row d-flex justify-content-around mt-5 mb-3" style="width: 20vw;">
        <button @click="deleteModal=!deleteModal" class="btn btn-primary btn-back" type="submit">برگشت</button>
        <button class="btn btn-primary btn-approve" @click="deleteItemForm(id)">تایید</button>
      </div>
    </div>
  </div>
  <!-- modal  -->
  <!-- modal  -->




</template>

<script>
import Splash from "@/components/Splash/Splash";
import Sidebar from "@/components/Sidebar/Sidebar";
import router from "@/router";
import {useToast} from "vue-toastification";
import Reset from "@/components/Icons/Reset.vue";
import vSelect from "vue-select";
const toast = useToast();

export default {
  name: "ListOrganization",
  components: {vSelect, Reset, Sidebar, Splash},
  data() {
    return {
      id: '',
      name: '',
      addModal: false,
      editModal: false,
      infoModal: false,
      deleteModal: false,
      Error: false,
      ErrorM: '',
      searchUser: '',
      // users

      all_items: [],
      count: 0,
       id_item: '',
      parent_item: '',

    }
  },
  methods: {




    editModalMethod(id,title,parent) {
      this.id = id
      this.name = title
      this.editModal = true
      this.parent_item = parent




    },
    deleteModalMethod(id) {
      this.id = id
      this.deleteModal = true
    },
    deleteItemForm(id) {
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);

      var formdata = new FormData();


      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };

      fetch(`${this.base_url}/OrganizationUnits/destroy/${id}`, requestOptions)
          .then(response => response.json())
          .then(result => {
            if (result.error) {
              toast.error(result.error)
              result;
            }
            if (result.message){
              this.deleteModal = false
              this.all_items.length = 0
              this.fetchAll()
              toast.success(result.message)
            }


          })
          .catch();
    },
    resetItems(){
      this.name = ''
      this.editModal = false
      this.parent_item = ''
    },
    submitForm() {
      setTimeout(() => {
        if (this.name.length === 0) {
           this.ErrorM = 'عنوان اجباری است!'
           toast.error(this.ErrorM)

          return;
        }


        fetch(`${this.base_url}/OrganizationUnits/store`, {
          method: 'POST',
          headers: {
            "Authorization": `Bearer ${this.$cookies.get('token')}`,
            'Content-type': 'application/json; charset=UTF-8',
          },
          body: JSON.stringify({
            'title': this.name,
            'parent_id': this.parent_item && this.parent_item.code,



          }),
        })
            .then(response => response.json())
            .then((response) => {
              if (response['error']) {
                toast.error(response.error)
                return
              }
              if (response.message){
                toast.success(response.message)
                this.all_items.length = 0
                this.fetchAll()
                this.resetForm()
              }





            }).catch((err) => {
        })


      }, 1000)
    },
    update(id) {

      
      setTimeout(() => {
        if (this.name.length === 0) {
          this.Error = !this.Error
          this.ErrorM = 'عنوان   اجباری است!'
          this.loading = false

          return;
        }


        fetch(`${this.base_url}/OrganizationUnits/update/${id}`, {
          method: 'POST',
          headers: {
            "Authorization": `Bearer ${this.$cookies.get('token')}`,
            'Content-type': 'application/json; charset=UTF-8',
          },
          body: JSON.stringify({
            'title': this.name,
            'parent_id': this.parent_item && this.parent_item.code,



          }),
        })
            .then(response => response.json())
            .then((response) => {
              if (response['error']) {
                toast.error(response.error)
                return
              }
              if (response.message){
                toast.success(response.message)

                this.editModal = !this.editModal
                this.all_items.length = 0
                this.resetItems()
                this.fetchAll()
                this.resetForm()
              }



            }).catch((err) => {
        })


      }, 1000)
    },
    resetForm() {
      this.name = ''
      this.substituteName = ''
      this.curatorName = ''
      this.parentName = ''
    },

    fetchAll() {
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);

      var formdata = new FormData();


      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };

      fetch(`${this.base_url}/OrganizationUnits`, requestOptions)
          .then(response => response.json())
          .then(result => {
            if (result['all'].length !== 0) {
              this.all_items.length=0
              result['all'].forEach(item => {
                this.all_items.push(item)

              })

            }

          })
          .catch();
    },

  },
  mounted() {
    this.fetchAll()
  },
  computed: {



  },
}
</script>

<style scoped>
label {
  width: 100%;
  text-align: right;
}

table {
  background-color: white !important;
}


img {
  cursor: pointer;
}

tr {
  background-color: #ffff !important;
}
.changer{
  background-color: #AFAFAF;
  height: 2vw;
  border-radius: 1vw;
  width: 10vw;
  margin-bottom: 2vw;
  justify-content: space-evenly;
  &>p:nth-child(1){
    width: 11vw;
    height: 2vw;
    background-color: #3742FA;
    color: #fff;
    transform: translateX(.9vw);
    border-radius: 1vw;
  }
  &>p:nth-child(2){
    margin-left: 1vw;
  }  &>p {
       cursor: pointer;
       font-size: 1vw;
     }
  &>a{
    color: black;
    text-decoration: none;
    margin-left: .9vw;
  }
}
</style>